'use strict';

const isMobile = window.matchMedia('(max-width: 768px)').matches;

function setupSnapMint() {
    const snapmintOfferEle = document.querySelector('[data-snapmint-offer]'),
        snapmintScript = snapmintOfferEle.getAttribute('data-actionurl');

    let removeElements = '';

    if (isMobile) {
        removeElements = '[data-snapmint-visiblefor="desktop"]'
    } else {
        removeElements = '[data-snapmint-visiblefor="mobile"]'
    }

    document
        .querySelectorAll(removeElements)
        .forEach(el => el.remove());

    loadSnapmintScript(snapmintScript);
}

function loadSnapmintScript(snapmintScript) {
    const fullSrc = ('https:' == document.location.protocol ? 'https://' : 'http://') + snapmintScript,
        existingScript = document.querySelector(`script[src="${fullSrc}"]`);

    var snapmint = document.createElement('script'),
        script0 = document.getElementsByTagName('script')[0];

    // Check if script already exists
    if (existingScript) {
        return;
    }

    // Create new script
    snapmint.type = 'text/javascript';
    snapmint.async = true;
    snapmint.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + snapmintScript;

    script0.parentNode.insertBefore(snapmint, script0);
}

setupSnapMint();
